import { render, staticRenderFns } from "./RunningPrediction.vue?vue&type=template&id=1792a0df&scoped=true&"
import script from "./RunningPrediction.vue?vue&type=script&lang=js&"
export * from "./RunningPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792a0df",
  null
  
)

export default component.exports